import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class PhysicalExaminationInduction extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      
      AnteNatalHistoryPreviousObstetricUltrasound: "",
      AnteNatalHistoryNumPreviousUltrasound: "",
      AnteNatalHistoryTableTrimester: "",
      AnteNatalHistoryTableDate: "",
      AnteNatalHistoryTableResult: "",
      myParentTrigger: "",
      DataLoaded: false,
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".hiddenPart").show();
    });
    $(".noAnswer").click(function () {
      $(".hiddenPart").hide();
    });

    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    axios
      .get(this.api_url+""+localStorage.getItem('currentModule')+"/physicalexam/inductionindex", {
        headers: headers,
      })
      .then((res) => {
        //   const verified = res.data;
        // console.log(res.data[0]['module'])
        // console.log(res.data)

        for (var i = 0; i < res.data.length; i++) {
          // console.log(res.data[i])

          var number = i + 1;
          // console.log()
          // var split = res.data[i]['timeofopen'].split(" ");
          // var date = split[0]
          // var time = split[1]

          let tableinit = res.data;

          // console.log(typeof(table))
          let object = {};
          for (let i = 0; i < tableinit.length; i++) {
            delete tableinit[i]._id;
            delete tableinit[i].timeOfRegistration;
            tableinit[i].clickEvent = () => this.handleRowClick(tableinit[i]);
          }
          // table = JSON.stringify(table);
          var visitId = res.data[i]["visitid"].split("_");
          var visitNumber = { visitNumber: visitId[2] };
          var serialNumber = { serialNumber: visitId[1] };

          var table = Object.assign(tableinit, visitNumber, serialNumber);

          // alert(table)
          this.TableData = table;
          // console.log(this.TableData);
          this.setState({
            DataLoaded: true,
          });

        }

       
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }
  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}
  
  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    // console.log(data)
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};

      trimobj.column0 = data[i][1];
      trimobj.column1 = data[i][2];
      trimobj.column2 = data[i][3];
      trimobj.column3 = data[i][4];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    // let PreviousObstetricUltrasound = event.target[0].value;
    // let NumPreviousUltrasound = event.target[1].value;
    // for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
    var columns = ["column0", "column1", "column2", "column3"];
    for (var i = 0; i < columns.length; i++) {
      var dict = {
        Dilatation: this.state.tablevaluesglobal[0][columns[i]],
        Effacement: this.state.tablevaluesglobal[1][columns[i]],
        Consistence: this.state.tablevaluesglobal[2][columns[i]],
        Position: this.state.tablevaluesglobal[3][columns[i]],
        Station: this.state.tablevaluesglobal[4][columns[i]],
        Total: this.state.tablevaluesglobal[5][columns[i]],
      };
      // let finalpayload = {};
      // finalpayload.inductionindex = this.state.tablevaluesglobal;
      // // console.log(finalpayload);
      this.setState({
        loading: true
      })
      console.log(dict)

      axios
        .post(
          this.api_url+""+localStorage.getItem('currentModule')+"/physicalexam/inductionindex",
          dict,
          { headers: headers }
        )
        .then((response) => {
          this.setState({
            loading: false
          })
          console.log(response)
          if (response.status == 200) {
            $("#SubmitSuccess").show();
            $("#SubmitError").hide();
            // $(".dataTableClass").show();
            setTimeout(function () {
              // window.location.href = "/treatment";
            }, 500);
          } else {
            $("#SubmitSuccess").hide();
            $("#SubmitError").show();

            // $(response).each(function (index) {
            //     var individualResult = '<div className="card"> <div className="card-body">' + index.name + '</div> </div>'
            //     $('.resultDisplay').append(individualResult);
            // });
            // $('.resultDisplay').show();
            this.setState({ response: response });
            // console.log(response)resultDisplay
            // /
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
          $("#SubmitSuccess").hide();
          $("#SubmitError").show();
          console.log(error);
        });
    }

    // }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  render() {
    //Editable table variables
    const data = [
      ["Dilatation", "", "", "", ""],
      ["Effacement", "", "", "", ""],
      ["Consistence", "", "", "", ""],
      ["Position", "", "", "", ""],
      ["Station", "", "", "", ""],
      ["Total", "", "", "", ""],
      // ["4th", "", ""],
    ];
    const columns = ["Directory", "0", "1", "2", "3"];

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    let { DataLoaded, loading} = this.state;
    const tabledata = {
      columns: [
        {
          label: "Directory",
          field: "Directory",
          sort: "asc",
          width: 50,
        },
        {
          label: "Dilatation",
          field: "Dilatation",
          sort: "asc",
          width: 50,
        },
        {
          label: "Effacement",
          field: "Effacement",
          sort: "asc",
          width: 50,
        },
        {
          label: "Consistence",
          field: "Consistence",
          sort: "asc",
          width: 50,
        },
        {
          label: "Position",
          field: "Position",
          sort: "asc",
          width: 50,
        },

        {
          label: "Station",
          field: "Station",
          sort: "asc",
          width: 50,
        },
        {
          label: "Total",
          field: "Total",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };

    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Physical Examination Bishop Score
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <br />
              <div className="dataTableClass" style={displayHidden}>
                <MDBDataTable striped bordered data={tabledata} />
              </div>

              <div style={displayHidden} className="col col-6">
                <a
                  href="/tests/to/be/done"
                  className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold"
                  type="button"
                  style={floatRight}
                >
                  Send To Lab
                </a>
              </div>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? "Loading" : "Submit"}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PhysicalExaminationInduction;
